import dayjs from "../shared/helpers/dayjs";

import { UK_DATE_FORMAT } from "../const/DateFormatConsts";

import { gaEvent } from "../shared/helpers/gtm_tracking";

function getQueryString() {
  return window.location.search;
}

function getQueryParams() {
  return exports.getQueryString().substr(1).split("&").reduce((params, paramStr) => {
    const paramPair = paramStr.split("=");

    if (paramPair[0]) {
      params[decodeURIComponent(paramPair[0])] = decodeURIComponent(paramPair[1]);
    }

    return params;
  }, {});
}

function queryStringFromParams(queryParams) {
  const queryString = [];

  Object.keys(queryParams).forEach(function (key) {
    const value = queryParams[key];

    if (value) {
      queryString.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  });

  return queryString.length ? `?${queryString.join("&")}` : "";
}

function getParamByName(name) {
  return getQueryParams()[name];
}

function venueParamsToUrl(newParams) {
  const params = getQueryParams();
  const hash = window.location.hash;

  delete params.package;
  delete params.arrival_date;
  delete params.offers_only;

  if (newParams.package_id) {
    params.package = newParams.package_id;
  }

  if (newParams.arrival_date) {
    params.arrival_date = newParams.arrival_date;
  }

  if (newParams.offers_only) {
    params.offers_only = newParams.offers_only;
  }

  const queryString = queryStringFromParams(params);

  return `/${newParams.venue_slug}${queryString}${hash}`;
}

function checkAndAddSegment(params, urlSegments, key) {
  if (key in params && params[key]) {
    urlSegments.push(key, params[key]);
  }
}

function paramsToUrl(params) {
  const urlSegments = [];

  if (params.date) {
    urlSegments.push('date', params.date.format(UK_DATE_FORMAT));
  }

  if (params.region) {
    urlSegments.push(params.region);
  }

  checkAndAddSegment(params, urlSegments, 'nights');
  checkAndAddSegment(params, urlSegments, 'rounds');
  checkAndAddSegment(params, urlSegments, 'sort');

  if (params.place && params.bounding_box) {
    urlSegments.push('place', encodeURIComponent(params.place), encodeURIComponent(params.bounding_box));
  }

  const url = `/${urlSegments.join('/') || 'search'}`;

  gaEvent("Search", "Criteria", url);

  return url;
}

function checkAndAddParam(urlSegments, params, key, name) {
  const index = urlSegments.indexOf(name || key);

  if (index !== -1) {
    params[key] = (name ? `${name}/` : '') + urlSegments[index + 1];
  }
}

function getURLParams(path) {
  const urlSegments = path.split("/");
  const params = {};
  const dateIndex = urlSegments.indexOf('date') + 1;

  if (dateIndex) {
    const dateString = urlSegments.slice(dateIndex, dateIndex + 3).join('/');
    const date = dayjs(dateString, UK_DATE_FORMAT);

    if (date.isValid() && date.format(UK_DATE_FORMAT) === dateString) {
      params.date = date;
    }
  }

  checkAndAddParam(urlSegments, params, 'region', 'golf-holidays');
  checkAndAddParam(urlSegments, params, 'region', 'golf-breaks');

  if (urlSegments.indexOf('uk-golf-breaks') >= 0) {
    params.region = 'uk-golf-breaks';
  }

  checkAndAddParam(urlSegments, params, 'nights');
  checkAndAddParam(urlSegments, params, 'rounds');
  checkAndAddParam(urlSegments, params, 'sort');

  if (urlSegments.indexOf('place') >= 0) {
    const placeIndex = urlSegments.indexOf('place') + 1;

    params.place = decodeURIComponent(urlSegments[placeIndex]);
    params.bounding_box = decodeURIComponent(urlSegments[placeIndex + 1]);
  }

  return params;
}

function replaceUrl(params) {
  if (history.replaceState) {
    const url = paramsToUrl(params) + exports.getQueryString();

    history.replaceState("", "", url);
  }
}

export {
  getParamByName,
  getQueryString,
  getURLParams,
  paramsToUrl,
  replaceUrl,
  venueParamsToUrl
};



// WEBPACK FOOTER //
// ./services/URLService.js